import Star20 from '@carbon/icons-react/es/star/20';
import { Col, Row } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CsatRating } from 'api/tasks';
import { HelperText01, Text02 } from 'components/styles';
import { Responses } from './responses';
import { Box, Title, Waiting } from './styles';

const StarIcon = styled(Star20)`
  color: var(--warning-color);
`;

const StarCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`;

const StarBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  background-color: var(--white-100);
  width: 100%;
`;

const Text = styled.p`
  font-size: var(--font-size-sm);
`;

const Stars = () => {
  const getStars = () => {
    const arr: React.ReactNode[] = [];

    for (let i = 1; i <= 5; i += 1) {
      arr.push(
        <StarCol span={4} key={i + 1}>
          <StarBox>
            <StarIcon />
          </StarBox>
          {[1, 5].includes(i) && (
            <Text>
              <FormattedMessage id={`csat.rating.${i}`} />
            </Text>
          )}
        </StarCol>,
      );
    }

    return arr;
  };

  return <Row justify="space-between">{getStars().map((s) => s)}</Row>;
};

const Description = styled.div`
  ${HelperText01};
  ${Text02};
  padding: var(--spacing-05);
`;

interface CsatProps {
  name: string;
  isWaiting: boolean;
  ratings: CsatRating[];
}

export const Csat: FC<CsatProps> = (props) => {
  const { name, isWaiting, ratings } = props;

  return (
    <div data-cy="task_drawer.additional_info.csat">
      {!isWaiting && !ratings.length && (
        <Description>
          <FormattedMessage id="csat.description" />
        </Description>
      )}
      <Box>
        <Title>
          <FormattedMessage id="csat.question" values={{ name }} />
        </Title>
        {isWaiting && (
          <Waiting>
            <div>
              <FormattedMessage id="csat.waiting" />
            </div>
            <div>
              <FormattedMessage id="csat.waiting.message" />
            </div>
          </Waiting>
        )}
        {!isWaiting && !ratings.length && <Stars />}
        {Boolean(ratings.length) && <Responses data={ratings} />}
      </Box>
    </div>
  );
};
